const USER_FETCH_REQUESTED = "USER_FETCH_REQUESTED";
const USER_FETCH_SUCCEEDED = "USER_FETCH_SUCCEEDED";
const USER_FETCH_FAILED = "USER_FETCH_FAILED";

const CHANGE_UNIVERSITY = "CHANGE_UNIVERSITY";
const CHANGE_QUERY = "CHANGE_QUERY";
const CHANGE_QUERY_REQUESTED = "CHANGE_QUERY_REQUESTED";

const SEARCH_REQUESTED = "SEARCH_REQUESTED";
const SEARCH_SUCCEEDED = "SEARCH_SUCCEEDED";
const SEARCH_FAILED = "SEARCH_FAILED";

const PROFESSOR_REQUESTED = "PROFESSOR_REQUESTED";
const PROFESSOR_SUCCEEDED = "PROFESSOR_SUCCEEDED";
const PROFESSOR_FAILED = "PROFESSOR_FAILED";

const NEW_COMMENT_TEXT_CHANGED = "NEW_COMMENT_TEXT_CHANGED";
const NEW_COMMENT_REQUESTED = "NEW_COMMENT_REQUESTED";
const NEW_COMMENT_SUCCEEDED = "NEW_COMMENT_SUCCEEDED";
const NEW_COMMENT_FAILED = "NEW_COMMENT_FAILED";

const INAPPROPRIATE_REQUESTED = "INAPPROPRIATE_REQUESTED";
const INAPPROPRIATE_SUCCEEDED = "INAPPROPRIATE_SUCCEEDED";
const INAPPROPRIATE_FAILED = "INAPPROPRIATE_FAILED";

const COMMENT_VOTE_REQUESTED = "COMMENT_VOTE_REQUESTED";
const COMMENT_VOTE_SUCCEEDED = "COMMENT_VOTE_SUCCEEDED";
const COMMENT_VOTE_FAILED = "COMMENT_VOTE_FAILED";

const PROF_VOTE_REQUESTED = "PROF_VOTE_REQUESTED";
const PROF_VOTE_SUCCEEDED = "PROF_VOTE_SUCCEEDED";
const PROF_VOTE_FAILED = "PROF_VOTE_FAILED";

export {
	USER_FETCH_REQUESTED,
	USER_FETCH_SUCCEEDED,
	USER_FETCH_FAILED,
	CHANGE_UNIVERSITY,
	CHANGE_QUERY,
	CHANGE_QUERY_REQUESTED,
	SEARCH_REQUESTED,
	SEARCH_SUCCEEDED,
	SEARCH_FAILED,
	PROFESSOR_REQUESTED,
	PROFESSOR_SUCCEEDED,
	PROFESSOR_FAILED,
	NEW_COMMENT_TEXT_CHANGED,
	NEW_COMMENT_REQUESTED,
	NEW_COMMENT_SUCCEEDED,
	NEW_COMMENT_FAILED,
	INAPPROPRIATE_REQUESTED,
	INAPPROPRIATE_SUCCEEDED,
	INAPPROPRIATE_FAILED,
	COMMENT_VOTE_REQUESTED,
	COMMENT_VOTE_SUCCEEDED,
	COMMENT_VOTE_FAILED,
	PROF_VOTE_REQUESTED,
	PROF_VOTE_SUCCEEDED,
	PROF_VOTE_FAILED
};



// WEBPACK FOOTER //
// ./src/actions.js